import {
  base200,
  informative100,
  maybeBlue700,
} from '@prisjakt/design-tokens/light-theme-colors';
import { Card } from '@prisjakt/ui/card';
import { Clickable } from '@prisjakt/ui/clickable';
import styled from 'styled-components';
import { layout, media } from 'src/components/base';

export const MessageWrapper = styled(Card)<{ $elevated?: boolean }>`
  ${p => !p.$elevated && `border: 1px solid ${base200};`}
  background-color: ${informative100};
  padding: ${layout.measurements.spacing050} ${layout.measurements.spacing100};
  flex-direction: row;
  margin-bottom: ${layout.measurements.spacing050};
  gap: ${layout.measurements.spacing050};

  > svg {
    width: 20px;
    height: 20px;

    > path {
      fill: rgba(0, 22, 36, 0.72);
    }
  }

  > img {
    max-height: 52px;
    max-width: 52px;
    align-self: center;
  }

  ${p =>
    p.$elevated &&
    `box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12);`}
`;

export const MessageGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;

  ${media.smallOnly`
    align-items: flex-start;
    flex-direction: column;
  `}
`;

export const Message = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
  align-items: center;

  > a {
    text-decoration: underline;

    &:hover {
      color: ${maybeBlue700};
    }
  }

  > h4 {
    margin: 0;
  }

  ${media.smallOnly`
    flex-direction: column;
    align-items: baseline;
  `}
`;

export const StyledLink = styled(Clickable)`
  margin: ${layout.measurements.spacing050} 0;
  text-decoration: underline;
`;
